import axios from '@/plugins/axios'

const apiEndPoint = 'admin/sales-agent'
const apiExport = 'export/customer-list'

export default {
    namespaced: true,

    state: {
        agentlist: [],
        daterange: [],
        agentdetail: {},
        page: 0,
        option: {
            roles: 'sales-agent',
            isVerified: 'approve'
        }
    },

    getters: {

    },

    mutations: {
        setAgentlist (state, agentlist) {
            state.agentlist = agentlist
        },
        setAgentdetail (state, saleAgent) {
            state.agentdetail = saleAgent
        },
        setOption (state, optionData) {
            state.option = optionData
        },
        setActiveAgent (state, optionData) {
            state.agentdetail.isActive = optionData
        },
        setPage (state, ePage) {
            state.page = ePage
        }
    },

    actions: {
        async fetchAgentlist (context) {
            const response = await axios.post(`${apiEndPoint}?page=${context.state.page}&perPage=50`, context.state.option)
            const agentlist = response
            context.commit('setAgentlist', agentlist.content.map(v => ({
                ...v,
                createdAt: new Date(new Date(v.createdAt).getTime() + (60 * 420 * 1000))
            })))
            var calTotal = response.totalItems / 50
            this.totalPage = Math.ceil(calTotal)
            return Math.ceil(calTotal)
        },

        async patchAgentlist (context) {
            const response = await axios.patch(`${apiEndPoint}/${context.state.agentdetail.id}`, context.state.agentdetail)
            const patchUpdate = response
            console.log(context.state.agentdetail)
            console.log(patchUpdate)
        },

        async getExportAgentlist (context) {
            const response = await axios.get(`${apiExport}?page=1&itemsPerPage=50`, { responseType: 'blob' })
            console.log(response)
        }
    }
}
